import { useAppSelector } from "../store/store";
import { UserSelector } from "@imagine/frontend-base";
import { Layout } from "../components";
import { KeyPage, PagesApi, Api } from "@imagine/web-base";
import { useCallback, useEffect, useState } from "react";
import { Tools } from "@imagine/frontend-base";
import { useSearchParams } from "react-router-dom";
import { usePhpBackend } from "project";

export const LayoutContainer = () => {
  const user = useAppSelector(UserSelector.getUserNotNull);
  const phpBackend = usePhpBackend();
  const [keyPages, setKeyPages] = useState<KeyPage[]>([]);
  const [searchParams] = useSearchParams();

  const loadKeyPages = useCallback(async () => {
    const response = await PagesApi.getKeyPages(phpBackend);
    if (response.success && response.data) {
      setKeyPages(response.data);
    }
  }, [phpBackend]);

  useEffect(() => {
    loadKeyPages();
  }, [loadKeyPages]);

  const logVisit = useCallback(async () => {
    console.log("Logging visit");
    const source = document.referrer;

    const fbclid = searchParams.get("fbclid");
    if (fbclid) {
      localStorage.setItem("fbclid", fbclid);
    }

    const data = {};
    const utmSource = searchParams.get("utm_source");
    if (utmSource) {
      data["utmSource"] = utmSource;
      const utmMedium = searchParams.get("utm_medium");
      if (utmMedium) {
        data["utmMedium"] = utmMedium;
      }
      const utmCampaign = searchParams.get("utm_campaign");
      if (utmCampaign) {
        data["utmCampaign"] = utmCampaign;
      }
      const utmContent = searchParams.get("utm_content");
      if (utmContent) {
        data["utmContent"] = utmContent;
      }
      console.log("UTM parameters", data);
    }

    let path = "api/stats/log-visit";
    if (utmSource) {
      path += "/" + utmSource;
    } else if (source) {
      path += "/" + Tools.sanitizeUrl(source);
    }

    const result = await Api.post(path, data);
    if (result.success && result.data) {
      const trackingId = result.data.trackingId;
      if (trackingId > 0) {
        console.log("Setting tracking ID: " + trackingId);
        const currentTrackingId = localStorage.getItem("trackingId");
        if (currentTrackingId === null) {
          localStorage.setItem("trackingId", trackingId);
        }
      }
    } else {
      console.error("Failed to set tracking ID");
    }
  }, []);

  const addTrackingParameter = useCallback((key: string, value: string) => {
    const currentValue = localStorage.getItem(key);
    if (currentValue === null || currentValue === "") {
      localStorage.setItem(key, value);
      return true;
    }
    return false;
  }, []);

  const trackSource = useCallback(() => {
    const utmSource = searchParams.get("utm_source");
    if (utmSource) {
      // Detailed tracking
      addTrackingParameter("source", utmSource);
    } else {
      if (localStorage.getItem("source")) return;
      // Track only previous website (if not already tracked)
      const source = Tools.sanitizeUrl(document.referrer);
      addTrackingParameter("source", source);
    }

    // const previousSource = localStorage.getItem("source");
    // if (previousSource === null || previousSource === "") {
    //   const utmSource = searchParams.get("utm_source");
    //   if (utmSource) {
    //     localStorage.setItem("source", utmSource);
    //   } else {
    //     var source = Tools.sanitizeUrl(document.referrer);
    //     localStorage.setItem("source", source);
    //   }
    // }
  }, []);

  useEffect(() => {
    trackSource();
    const timeout = setTimeout(() => {
      logVisit();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [trackSource, logVisit]);

  return <Layout user={user} keyPages={keyPages} />;
};
